function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.293 8.293a1 1 0 001.414 1.414L.293 8.293zm9.414-6.586A1 1 0 008.293.293l1.414 1.414zm-1.414 8a1 1 0 001.414-1.414L8.293 9.707zM1.707.293A1 1 0 00.293 1.707L1.707.293zm0 9.414l8-8L8.293.293l-8 8 1.414 1.414zm8-1.414l-8-8L.293 1.707l8 8 1.414-1.414z",
  fill: "currentColor"
});
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none"
  }, props), _ref);
}
export default SvgClose;